import { Component, OnInit, Input, ElementRef, ViewChild } from "@angular/core";
import { Location } from "@angular/common";
import { ActivatedRoute, Params } from "@angular/router";
import { Router } from "@angular/router";
import * as moment from "moment";
import {
  FormBuilder,
  FormGroup,
  FormArray,
  Validators,
  FormControl
} from "@angular/forms";

@Component({
  selector: "app-periodo-escolar-formulario",
  templateUrl: "./formulario.component.html"
})
export class FormularioComponent implements OnInit{
  dato: FormGroup;
  tab = 1;
  tamano = document.body.clientHeight;
  contador_cambio = 0;
  hacer = true;
  periodo_anterior_nombre = '';
  date = new Date();
  MinDate = moment(
    new Date(this.date.getFullYear(), this.date.getMonth(), 1)
  ).format("YYYY-MM-DD");
  tieneid = false;

  ciclos_escolares_id: string = null;
  temp_ciclos_escolares_id: string = null;

  form_periodos_escolares_parciales;

  CkeditorConfig = {
    height: document.body.clientHeight - 460
  }
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.dato = this.fb.group({
      id: [""],
      nombre: ["", [Validators.required]],
      modalidades_id: [{ value: 1, disabled: this.tieneid && this.dato.controls.continuado.value == 1 }, [Validators.required]],
      tipos_periodos_id: [{ value: 1, disabled: this.tieneid && this.dato.controls.continuado.value == 1 }, [Validators.required]],
      fecha_inicio: ["", [Validators.required]],
      fecha_fin: ["", [Validators.required]],
      fecha_reinscripcion: ["", [Validators.required]],
      periodo_escolar_anterior: [{ value: 1, disabled: this.tieneid && this.dato.controls.continuado.value == 1 }],
      ciclos_escolares_id: ["", [Validators.required]],
      continuado: [0],
      vigente: ['0', [Validators.required]],
      nota_alumnos: [''],
      nota_docentes: [''],
      periodos_escolares_colegiaturas: this.fb.array([])
    });

    //Solo si se va a cargar catalogos poner un <a id="catalogos" (click)="ctl.cargarCatalogo('modelo','ruta')">refresh</a>
    document.getElementById("catalogos").click();

    this.route.params.subscribe(params => {
      if (params["id"]) {
        this.tieneid = true;
        this.hacer = false;
        if (this.tieneid && this.dato.controls.continuado.value == 1) {

        }
      }
    });
  }


  limpiar_pagos() {
    this.dato.controls.periodos_escolares_colegiaturas = this.fb.array([]);
  }

  obtener_nombre() {
    moment.locale("es");
    let inicio = this.dato.controls.fecha_inicio.value;
    let fin = this.dato.controls.fecha_fin.value;

    let mes_inicio = moment(inicio).format("MMMM");
    let anio_inicio = moment(inicio).format("YYYY");

    let mes_fin = moment(fin).format("MMMM");
    let anio_fin = moment(fin).format("YYYY");

    let nombre =
      mes_inicio.toUpperCase() +
      " " +
      anio_inicio +
      " - " +
      mes_fin.toUpperCase() +
      " " +
      anio_fin;
    if (inicio != "") {
      this.dato.controls.nombre.patchValue(nombre);
    }
  }

  procesa_periodo(periodos) {
    let i = 0;
    periodos.forEach(element => {
      if (element.continuado == 1) {
        periodos.splice(i, 1);
      }
      i++;
    });
    if (this.tieneid) {
      let i = 0;
      periodos.forEach(element => {
        if (element.id == this.dato.controls.id.value) {
          periodos.splice(i, 1);
          this.periodo_anterior_nombre = element.nombre;
        }
        i++;
      });

      i = 0;
      periodos.forEach(element => {
        if (element.modalidades_id != this.dato.controls.modalidades_id.value) {
          periodos.splice(i, 1);
        }
        i++;
      });

      i = 0;
      periodos.forEach(element => {
        if (
          element.tipos_periodos_id !=
          this.dato.controls.tipos_periodos_id.value
        ) {
          periodos.splice(i, 1);
        }
        i++;
      });
    }
  }

  cambio_periodo(periodos, modelo) {
    if (this.tieneid && this.contador_cambio > 1) {
      this.hacer = true;
    }
    if (this.hacer) {
      setTimeout(() => {
        if (this.dato.get("tipos_periodos_id")) {
          let periodo;
          periodos.forEach(element => {
            if (element.id == this.dato.get("tipos_periodos_id").value) {
              periodo = element;

              let minimo = this.dato.get("fecha_inicio").value;
              let maximo = new Date(
                this.date.getFullYear(),
                this.date.getMonth() + 1,
                1
              );
              let mes = this.date.getMonth() + 1;
              for (let index = 0; index < periodo.duracion_meses; index++) {
                // if (index > 0) {
                minimo = new Date(
                  this.date.getFullYear(),
                  this.date.getMonth() + index,
                  1
                );
                maximo = new Date(
                  this.date.getFullYear(),
                  this.date.getMonth() + index,
                  30
                );
                mes = mes + index;
                // }
                let objeto = {
                  numero_mensualidad: index + 1,
                  fecha_pago: [
                    this.tieneid ? "" : moment(minimo).format("YYYY-MM-DD"),
                    [Validators.required]
                  ],
                  min_date: [moment(minimo).format("YYYY-MM-DD")],
                  max_date: [moment(maximo).format("YYYY-MM-DD")]
                };
                modelo.push(this.fb.group(objeto));
              }
            }
          });
        }
      }, 100);
    }
    this.contador_cambio++;
  }

  cambio_periodo_escolar(periodos) {
    if ( this.dato.controls.periodo_escolar_anterior.value == null || this.dato.controls.periodo_escolar_anterior.value == "" ) {
      this.dato.get("tipos_periodos_id").disable();
      this.dato.get("modalidades_id").disable();
    }
    periodos.forEach(element => {
      if (this.dato.controls.periodo_escolar_anterior.value == element.id) {
        if (this.dato.controls.modalidades_id.value != element.modalidades_id) {
          this.dato.controls.modalidades_id.setValue(element.modalidades_id);
          this.dato.get("modalidades_id").enable();
        }
        if ( this.dato.controls.tipos_periodos_id.value != element.tipos_periodos_id) {
          this.dato.controls.tipos_periodos_id.setValue(element.tipos_periodos_id);
          this.dato.get("tipos_periodos_id").enable();
        }
      }
    });
  }

  actualizar_disabled() {
    if (this.tieneid && this.dato.controls.continuado.value == 1 ) {
      this.dato.get("modalidades_id").disable();
      this.dato.get("tipos_periodos_id").disable();
      this.dato.get("periodo_escolar_anterior").disable();
    }
  }
}
